import { render } from "./courseRating.vue?vue&type=template&id=5402f140&scoped=true"
import script from "./courseRating.vue?vue&type=script&lang=js"
export * from "./courseRating.vue?vue&type=script&lang=js"

import "./courseRating.vue?vue&type=style&index=0&id=5402f140&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/CIS-school.vip.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5402f140"]])

export default __exports__